import React from "react";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/pro-solid-svg-icons";

import SectionCard from "../SectionCard";
import SubSection from "../SubSection";
import AppointmentInfo from "./components/AppointmentInfo";
import CommunicationEvents from "./components/CommunicationEvents";
import Services from "./components/Services";
import Agreements from "./components/Agreements";
import Signature from "./components/Signature";
import { KIOSK_COMMUNICATION_EVENT_TYPES } from "../../../../util/communication_statuses";

import "./index.scss";

const getLastCommunication = communications =>
  communications?.reduce((lastCommunication, current) =>
    (current.created_on || "").localeCompare(lastCommunication.created_on || "") > 0 ? current : lastCommunication
  );

const hasSignature = comm => comm?.events?.some(e => e.type === KIOSK_COMMUNICATION_EVENT_TYPES.CHECK_IN_ANSWERED && e.customer_signature);

const KioskCommunicationLog = ({ appointment, t }) => {
  const lastCommunication = getLastCommunication(appointment.kiosk_communications);
  if (!lastCommunication) return null;

  const dealerLocation = appointment.dealer_location;

  return (
    <div className="kiosk-communication-log">
      <SectionCard
        title={t("cc_kiosk_check_in_communication_log").message || "Kiosk Check-in Communication Log"}
        icon={<FontAwesomeIcon icon={faList} />}
        onContentBorder
      >
        <SubSection title={t("cc_appointment_information").message || "Appointment Information"}>
          <AppointmentInfo appointment={appointment} t={t} />
        </SubSection>

        {lastCommunication.events?.length > 0 && (
          <SubSection title={t("cc_communication_events").message || "Communication events"}>
            <CommunicationEvents events={lastCommunication.events} comm={lastCommunication} t={t} />
          </SubSection>
        )}

        {lastCommunication.agreed_interventions?.length > 0 && (
          <SubSection title={t("cc_accepted_scheduled_services").message || "Accepted scheduled services"}>
            <Services services={lastCommunication.agreed_interventions} dealerLocation={dealerLocation} t={t} />
          </SubSection>
        )}

        {lastCommunication.agreements?.length > 0 && (
          <SubSection title={t("cc_agreements").message || "Agreements"}>
            <Agreements agreements={lastCommunication.agreements} />
          </SubSection>
        )}

        {hasSignature(lastCommunication) && (
          <SubSection title={t("cc_signature").message || "Signature"}>
            <Signature events={lastCommunication.events} />
          </SubSection>
        )}
      </SectionCard>
    </div>
  );
};

export default withTranslation()(KioskCommunicationLog);
